module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("I")]), _vm._v(" "), _c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("DEFINITION AND EXAMPLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When words are selected and arranged in such a way that their meaning either arouses, or is obviously intended to arouse, aesthetic imagination, the result may be described as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("poetic diction.")]), _vm._v(" Imagination is recognizable as aesthetic, when it produces pleasure merely by its proper activity. Meaning includes the whole content of a word, or of a group of words arranged in a particular order, other than the actual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sounds")]), _vm._v(" of which they are composed. Thus, this book is concerned with a realm of human experience in which such an expression as ‘prophets old’ may, and probably will, ‘mean’ something quite different from ‘old prophets’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the question, what is poetry? has never been answered, everyone will agree at least thus far: that it is not merely so many waves in the air or ink-marks on a piece of paper—that it exists primarily in the world of consciousness. Language itself, we feel, only springs into being as it is uttered by men, or heard by men, or thought by men. Whatever poetry may be, then, it is something more than the signs or sounds by which it is conveyed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So decisive is this rule that the same sounds and signs may easily be vehicles of poetry at this place and not in "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("that, at this time and not at that, to this person and not to the other. To the author of the famous article in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackwood’s,")]), _vm._v(" none of the sounds and signs composing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Endymion")]), _vm._v(" were a vehicle of poetry. To the writer of this book few of those which compose the introductory section of Browning’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ring and the Book")]), _vm._v(" are a vehicle of poetry. To John Robinson of Bethnal Green "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paradise Lost")]), _vm._v(" is not a vehicle of poetry. This is elementary. But what I wish to emphasize is that, while we can blame or commiserate these individuals, as we choose, for not maintaining or cultivating, or for not having had the opportunity to cultivate and maintain, the requisite sensibility, it is, very strictly speaking, meaningless—unless by way of a forcible hyperbole—to accuse them of mistaking something that ‘is’ poetry for something that ‘is not’. The question of whether or no I can call a given group of words ‘poetry’ is, in fact, immediately dependent on my own inner experiences; and in constructing a theory of poetic diction, it is from those experiences that I am obliged to start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In view, however, of the predominantly personal direction taken by literary criticism during the last few decades, it may be well to point out here that to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("start")]), _vm._v(" from personal experience does not necessarily mean to finish with it. One may start from direct, personal, aesthetic experience without prejudice to the possibility of arriving in the end at some objective standards of criticism—standards which a young critic might set before himself as an aid to the eliminations of just those personal affections and associations—the accidents rather than the substance of poetry—which are always at hand to distort his judgement.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("EXAMPLES")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thlee-piecee bamboo, two-piecee puff-puff, walk-along inside, no-can-see.")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Up then crew the red, red, cock,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And up and crew the grey;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The eldest to the youngest said,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("‘’"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tis time we were away’.")])]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The cock he hadnacraw’d but once,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And clapped his wings at a’,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When the eldest to the youngest said,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Brother, we must awa’.’")])]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘The cock doth craw, the day doth daw,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The channerin’ worm doth chide;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gin we be miss’d out o’ our place,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A sair pain we maun bide.’")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("III")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Love is a sickness full of woes,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All remedies refusing;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A plant that with most cutting grows,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Most barren with best using.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Why so?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("More we enjoy it, more it dies;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If not enjoy’d, it sighing cries")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heigh ho!")])]), _vm._v(" "), _c('p', {
    staticClass: "poemt"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Love is a torment of the mind,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A tempest everlasting;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And Jove hath made it of a kind")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not well, nor full nor fasting.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Why so?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("More we enjoy it, more it dies;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If not enjoy’d, it sighing cries")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heigh ho!")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("IV")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The inferior priestess, at her altar’s side,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Trembling, begins the sacred rites of pride.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unnumbered treasures ope at once, and here")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The various offerings of the world appear;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From each she nicely culls with curious toil,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And decks the goddess with the glittering spoil.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This casket India’s glowing gems unlocks,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And all Arabia breathes from yonder box.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The tortoise here and elephant unite,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transform’d to combs, the speckled and the white.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Here files of pins extend their shining rows,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Puffs, powders, patches, Bibles, billets-doux.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now awful Beauty puts on all its arms;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The fair each moment rises in her charms,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Repairs her smiles, awakens every grace,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And calls forth all the wonders of her face;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sees by degrees a purer blush arise,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And keener lightnings quicken in her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The busy sylphs surround their darling care:")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("These set the head, and those divide the hair;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Some fold the sleeve, whilst others plait the gown;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And Betty’s praised for labours not her own.")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('sup', [_vm._v("v(a)")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("My soul is an enchanted boat,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Which, like a sleeping swan, doth float")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Upon the silver waves of thy sweet singing;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And thine doth like an angel sit")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Beside a helm conducting it,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whilst all the winds with melody are ringing….")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("v(b)")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What is your substance, whereof are you made,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That millions of strange shadows on you tend?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Since every one hath, every one, one shade,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And you, but one, can every shadow lend….")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Behold now this vast city, a city of refuge, the mansion-house of liberty, encompassed and surrounded with his protection; the shop of war hath not there more anvils and hammers waking, to fashion out the plates and instruments of armed justice in defence of beleaguered truth, than there be pens and heads there, sitting by their studious lamps, musing, searching, revolving new notions and ideas wherewith to present, as with their homage and their fealty, the approaching Reformation; others as fast reading, trying all things, assenting to the force of reason and convincement.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What could a man require more from a nation so pliant and so prone to seek after knowledge? What wants there to such a towardly and pregnant soil, but wise and faithful labourers, to make a knowing people, a nation of prophets, of sages, and of worthies? We reckon more than five months yet to harvest; "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("there need not be five weeks; had we but eyes to lift up, the fields are white already.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I have transcribed above six separate groups of English words, all of which have been proved capable, in one case, of arousing aesthetic imagination. To begin with, I shall ignore the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("difference")]), _vm._v(" between the sensations which the various examples are able to arouse, in an attempt to fix any elements which they have in common. The first example is Pidgin English for a three-masted screw steamer with two funnels. I have added it to the rest, in the first place, because it appears to me to be indisputable that such primitive and semi-foreign expressions often have value as poetic diction, and, in the second place, because, that being so, their very baldness is a great advantage. Detached from all historical associations and poetic tradition, and yet affecting us in a manner which is qualitatively the same as that of explicitly ‘poetic’ diction, they present, as it were, the lowest common measure of our subject.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384bf40c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 78
// module chunks = 0